import "antd/lib/table/style";
import _Table from "antd/lib/table";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty"; /*@通用组件-表格*/
import React from 'react';
import { AdaptiveCell } from "./adaptiveCell";
import './BossTable.scss';
var BossTable = /*#__PURE__*/function (_React$Component) {
  _inherits(BossTable, _React$Component);
  function BossTable(props) {
    var _this;
    _classCallCheck(this, BossTable);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BossTable).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (pagination, filters, sorter) {
      var component = _this.props.component ? _this.props.component : _assertThisInitialized(_assertThisInitialized(_this));
      if (_this.props.showMorePage) {
        component.setState(_defineProperty(_defineProperty(_defineProperty({}, _this.props.pageName, pagination.current), _this.props.pageSizeName, pagination.pageSize), "filteredInfo", filters), function () {
          if (_this.props.getData) {
            _this.props.getData();
          }
        });
      } else {
        component.setState({
          page_no: pagination.current,
          page_size: pagination.pageSize,
          filteredInfo: filters
        }, function () {
          if (_this.props.getData) {
            _this.props.getData();
          }
        });
      }
    });
    _this.state = {};
    return _this;
  }
  _createClass(BossTable, [{
    key: "render",
    value: function render() {
      var components = {
        body: {
          cell: AdaptiveCell
        }
      };
      var component = this.props.component;
      var pagination = {
        pageSize: component && component.state.page_size ? component.state.page_size : 20,
        total: this.props.total,
        current: component ? component.state.page_no : "",
        showSizeChanger: this.props.showSizeChanger,
        showQuickJumper: this.props.showQuickJumper,
        pageSizeOptions: this.props.pageSizeOptions ? this.props.pageSizeOptions : ["20", "50", "100"]
      };
      if (this.props.showMorePage) {
        pagination.current = component.state[this.props.pageName];
        pagination.pageSize = component.state[this.props.pageSizeName];
      }
      var paginationWithoutPaging = {
        pageSize: 20
      };
      return /*#__PURE__*/React.createElement(_Table, Object.assign({
        onChange: this.onChange,
        components: components,
        scroll: {
          x: 'max-content'
        },
        bordered: true,
        size: "middle",
        rowKey: function rowKey(record, key) {
          return record.id ? record.id : key;
        },
        locale: {
          emptyText: '暂无数据'
        },
        pagination: this.props.paging ? pagination : paginationWithoutPaging,
        rowClassName: "normal"
      }, this.props));
    }
  }]);
  return BossTable;
}(React.Component);
BossTable.defaultProps = {};
export default BossTable;